import type { TFunction } from "i18next"
import React, { createContext, useContext } from "react"

import { useAppContext } from "@contexts/app_context"
import useToggle from "@hooks/use_toggle"
import i18next from "@utils/localization"

export type EmailLogsFormData = {
  customerId?: string | undefined
  startDate?: Date
  endDate?: Date
  filterTrigger?: number
}

type EmailLogsPageContextProps = {
  translate: TFunction<"translation", undefined>
  isLeftDrawerOpen?: boolean
  toggleIsLeftDrawerOpen?: () => void
  filters: EmailLogsFormData
  setFilters: React.Dispatch<React.SetStateAction<EmailLogsFormData>>
}

const defaultValues: EmailLogsPageContextProps = {
  translate: i18next.t,
  filters: {},
  setFilters: () => {}
}

const EmailLogsPageContext = createContext(defaultValues)

export function EmailLogsPageContextProvider(props: {
  children: React.ReactNode | React.ReactNode[]
}) {
  const { translate } = useAppContext()
  const [isLeftDrawerOpen, toggleIsLeftDrawerOpen] = useToggle(true)
  const isDev =
    process.env.NODE_ENV === "development" ||
    process.env.ENV === "dev" ||
    process.env.REACT_APP_API_URL?.includes("dev")
  const [filters, setFilters] = React.useState<EmailLogsFormData>({
    customerId: isDev ? "6a604c828be5a11684412fc3" : undefined,
    startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
    endDate: new Date()
  })

  return (
    <EmailLogsPageContext.Provider
      value={{
        ...defaultValues,
        translate,
        isLeftDrawerOpen,
        toggleIsLeftDrawerOpen,
        filters,
        setFilters
      }}
    >
      {props.children}
    </EmailLogsPageContext.Provider>
  )
}

export function useEmailLogsPageContext() {
  const context = useContext(EmailLogsPageContext)
  if (context === undefined) {
    throw new Error("EmailLogsPageContext Error")
  }
  return context
}
